if (!customElements.get('sale-info-drawer')) {
  customElements.define(
    'sale-info-drawer',
    class SaleInfoDrawer extends HTMLElement {
      constructor() {
        super()

        this.onBodyClick = this.handleBodyClick.bind(this)
        this.onTriggerClick = this.handleTriggerClick.bind(this)

        document.addEventListener('click', this.onTriggerClick)

        // Overlay is a sibling element in the markup, not a child —
        // grab a reference to it here so show()/hide() can toggle it
        this.overlay = this.previousElementSibling?.classList.contains('sale-info-drawer__overlay')
          ? this.previousElementSibling
          : document.querySelector('.sale-info-drawer__overlay')

        this.overlay?.addEventListener('click', () => {
          this.hide()
        })

        this.querySelector('.sale-info-drawer__close')?.addEventListener(
          'click',
          () => {
            this.hide()
          }
        )

        this.addEventListener('keyup', (event) => {
          if (event.code?.toUpperCase() === 'ESCAPE') {
            this.hide()
          }
        })
      }

      handleTriggerClick(event) {
        const trigger = event.target.closest('.sale-info-trigger')

        if (!trigger) return

        this.show()
      }

      handleBodyClick(evt) {
        const target = evt.target

        if (
          target !== this &&
          !target.closest('sale-info-drawer') &&
          !target.closest('.sale-info-trigger')
        ) {
          this.hide()
        }
      }

      hide() {
        this.removeAttribute('open')
        this.overlay?.classList.remove('is-visible')
        document.body.removeEventListener('click', this.onBodyClick)
        document.body.classList.remove('overflow-hidden')
      }

      show() {
        this.setAttribute('open', '')
        this.overlay?.classList.add('is-visible')
        document.body.addEventListener('click', this.onBodyClick)
        document.body.classList.add('overflow-hidden')
      }
    }
  )
}